import { useSelector } from 'react-redux'
import routes from '../router/routes'
import { findRoute } from '../router/utils'
import routerSelectors from '../store/selectors/router'

const withFullRoute = () => {
  const route = useSelector(routerSelectors.route)
  return route ? findRoute(routes, route.name) : null
}

export default withFullRoute